import { render, staticRenderFns } from "./RequireRefreshDialog.vue?vue&type=template&id=0c1a6a23&"
import script from "./RequireRefreshDialog.vue?vue&type=script&lang=js&"
export * from "./RequireRefreshDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports